import React from 'react';
import cx from 'clsx';

import styles from '@danske/sapphire-css/components/skeleton/skeleton.module.css';

import { useSapphireStyleProps, useThemeCheck } from '../../utils';
import { SkeletonProps } from './skeleton.model';
import { getAnimationDelay } from './animation';

export type SkeletonBlockProps = SkeletonProps;

export const SkeletonBlock: React.FC<SkeletonBlockProps> = ({
  index,
  children,
  ...rest
}) => {
  useThemeCheck();

  const { styleProps, filteredProps } = useSapphireStyleProps(rest);
  const animationDelay = getAnimationDelay(index);

  return (
    <div
      {...filteredProps}
      style={{
        animationDelay,
        ...styleProps.style,
      }}
      className={cx(
        styles['sapphire-skeleton'],
        styles['sapphire-skeleton--block'],
        styleProps.className
      )}
    />
  );
};
